/* eslint-disable no-empty */
import { DBStoreParams, UpsertParams } from '../types';

const DEFAULT_PREFIX = 'cc.';

interface CompleteKeyParams {
  key: string;
  discriminator: string;
  prefix: string;
}

const completeKey = ({ key, discriminator, prefix }: CompleteKeyParams) =>
  prefix + discriminator + (discriminator?.length === 0 ? '' : '.') + key;

export const localPut = <T extends unknown>(
  { key, data, discriminator = '' }: UpsertParams<T>,
  prefix: string = DEFAULT_PREFIX
) => {
  try {
    localStorage.setItem(`${completeKey({ key, discriminator, prefix })}`, JSON.stringify(data));
  } catch {}
};

export const localDelete = (
  { key, discriminator }: DBStoreParams,
  prefix: string = DEFAULT_PREFIX
) => {
  try {
    localStorage.removeItem(`${completeKey({ key, discriminator, prefix })}`);
  } catch {}
};

export const localGet = <T extends unknown>(
  { key, discriminator = '' }: DBStoreParams,
  prefix: string = DEFAULT_PREFIX
) => {
  try {
    JSON.parse(localStorage.getItem(`${completeKey({ key, discriminator, prefix })}`)) as T;
  } catch {}
};
